'use strict';

/* globals config, $ */

require([
	config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js',
	'vendor/colorpicker/colorpicker',
], function (Vue) {
	var internals = {};

	Vue.component('color-answer-edit', {
		props: ['answer', 'initData'],
		mounted: function () {
			var me = this;

			if (!this.answer.content || this.answer.content.length === 0) {
				this.answer.content = '#333451';
			}

			internals.initColorPicker(this.$el, this.answer.content, function (color) {
				me.answer.content = color;
			});
		},
		template:
		'<div>' +
			'<div class="fg-line">' +
				'<label for="name">{{initData.translations.selectColor}}</label>' +
				'<button type="button" class="btn btn-default btn-sm" style="display: block; color: #fff" data-action="answer-color-select">{{initData.translations.answerColor}}</button>' +
			'</div>' +
		'</div>',
	});

	internals.initColorPicker = function (el, currentColor, changeCallback) {
		var settingsFormEl = $(el);
		var colorBtn = settingsFormEl.find('[data-action="answer-color-select"]');

		colorBtn.css('background-color', currentColor);

		colorBtn.ColorPicker({
			color: currentColor,
			onChange: function (hsb, hex) {
				changeCallback('#' + hex);
				colorBtn.css('background-color', '#' + hex);
			},
			onShow: function (colpkr) {
				$(colpkr).css('z-index', 1051);
			},
		});
	};

	internals.getDefaultGroupColor = function () {
		return '#333451';
	};
});
